import Event from "../event"


export function eventCalculateDisplayStartDate(event:Event) {

    // try init by value - zopoi chuvstvuu eto fignya i prived k bug...
    // if (event.displayStartDate) return event.displayStartDate

    // try init by startDate
    if (event.startDate) return event.startDate

    // we always need display dates... this is defualt but it will be redefined if any children...
    return momentDate()

}

export function eventCalculateDisplayEndDate(event:Event) {

    // // try init by value
    // if (obj.displayEndDate) obj.displayEndDate

    // try init by startDate
    if (event.endDate) return event.endDate

    // we always need display dates... this is defualt but it will be redefined if any children...
    return event.displayStartDate

}